import { useCallback, useState } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const useLocalStorage = (key: string, defaultValue: string) => {
  const { logger } = useApplicationContext();

  // Initialize with value from localStorage or defaultValue (lazy initialization)
  // This avoids state updates during render and SSR/hydration issues
  const [value, setValue] = useState<string>(() => {
    /* istanbul ignore if */
    if (typeof window === 'undefined') {
      return defaultValue;
    }

    try {
      const result = window.localStorage.getItem(key);

      return result !== null ? result : defaultValue;
    } catch (error) {
      logger.warning('Ошибка при получении значения из localstorage', error);

      return defaultValue;
    }
  });

  const setStorageValue = useCallback(
    (newValue: string) => {
      try {
        window.localStorage.setItem(key, newValue);
        setValue(newValue);
      } catch (error) {
        logger.warning('Ошибка при сохранении значения в localstorage', error);
      }
    },
    [key, logger],
  );

  const clearValue = useCallback(() => {
    try {
      window.localStorage.removeItem(key);
      setValue(defaultValue);
    } catch (error) {
      logger.warning('Ошибка при удалении значения из localstorage', error);
    }
  }, [key, logger, defaultValue]);

  return { value, setValue: setStorageValue, clearValue };
};
